import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';  // 追加

const firebaseConfig = {
    apiKey: "AIzaSyA1ehvRfntuaFc0xRFORS-zx13NrsKNu14",
    authDomain: "acematch-424cd.firebaseapp.com",
    projectId: "acematch-424cd",
    storageBucket: "acematch-424cd.appspot.com",
    messagingSenderId: "747685802702",
    appId: "1:747685802702:web:e54fbb919e962d5d52569f",
};

const app = initializeApp(firebaseConfig);  // Firebaseアプリを初期化
const auth = getAuth(app);
const db = getFirestore(app);
const messaging = getMessaging(app);
const storage = getStorage(app);
const functions = getFunctions(app);  // functions を追加
const provider = new GoogleAuthProvider();


// 必要なモジュールをエクスポート
export { app, auth, db, messaging, getToken, onMessage, provider, storage, functions };  // functions をエクスポート



